import { Version } from './versionConfig.definition';
import { versionConfig } from './versionConfig.state';

/**
 * Runtime version evaluator
 *
 * Centralized access layer for version selection.
 * Ensures consistent version behavior across the entire application.
 */
export const getActiveVersion = (): Version => versionConfig.active;

export const isVersion = (version: Version): boolean => versionConfig.active === version;
